import React from "react";
import { COLORS } from "../data/profile";
import { useLang } from "../LanguageContext";
import { useScrollReveal, useCountUp } from "./ScrollReveal";

function AnimatedStat({ number, label, suffix = "", prefix = "", delay = 0 }) {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.3 });
  const count = useCountUp(number, 2000, isVisible);

  return (
    <div
      ref={ref}
      className={`scroll-reveal ${isVisible ? "is-visible" : ""}`}
      style={{ textAlign: "center", transitionDelay: `${delay}ms` }}
    >
      <div className="impact-number">
        {prefix}{count}{suffix}
      </div>
      <div className="impact-label">{label}</div>
    </div>
  );
}

export default function ImpactNumbers() {
  const { lang } = useLang();

  const stats = [
    {
      number: 107,
      prefix: "€",
      suffix: "M+",
      label: { en: "Funding Facilitated", fr: "Financements Facilités" },
    },
    {
      number: 120,
      prefix: "",
      suffix: "K",
      label: { en: "Platform Users", fr: "Utilisateurs Plateforme" },
    },
    {
      number: 4,
      prefix: "",
      suffix: "",
      label: { en: "Countries", fr: "Pays" },
    },
  ];

  return (
    <section className="impact-section">
      <div className="impact-grid">
        {stats.map((stat, i) => (
          <AnimatedStat
            key={i}
            number={stat.number}
            prefix={stat.prefix}
            suffix={stat.suffix}
            label={stat.label[lang] || stat.label.en}
            delay={i * 150}
          />
        ))}
      </div>
    </section>
  );
}
